module.exports = __webpack_public_path__ + "static/img/4.b7dd9c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/4.png
// module id = AFEH
// module chunks = 0